import { Routes } from '@angular/router';

import { RootRedirectComponent } from './root-redirect.component';

export const routes: Routes = [
  {
    path: 'auth',
    loadChildren: () => import('./module/auth/auth.routes').then((m) => m.authRoutes),
  },
  {
    path: 'qrcode',
    loadChildren: () => import('./module/qrcode/qrcode.routes').then((m) => m.qrcodeRoutes),
  },
  { path: '', pathMatch: 'full', component: RootRedirectComponent },
];
